<template>

  <modalo
    :title="company.name"
    type="medium"
    @hideModal="hideModal()"
    :modaloWatch="() => company">
      
    <form id="company-form" v-on:submit.prevent="saveCompany(company)">
      <div class="form-group">
        <label>{{ $t('Name') }}</label>
        <input v-autofocus type="text" class="form-control" v-model="company.name">
        <ValidateMessage :error="validateErrors.name" />
      </div>
      <div class="row">
        <div class="col-sm">
          <div class="form-group">
            <label>{{ $t('Country') }}</label>
            <select-country v-model="company.country"></select-country>
            <ValidateMessage :error="validateErrors.country" />
          </div>
          <div class="form-group">
            <label>{{ $t('State') }}</label>
            <input type="text" class="form-control" v-model="company.region">
            <ValidateMessage :error="validateErrors.region" />
          </div>
          <div class="form-group">
            <label>{{ $t('City') }}</label>
            <input type="text" class="form-control" v-model="company.city">
            <ValidateMessage :error="validateErrors.city" />
          </div>
        </div>
        <div class="col-sm">
          <div class="form-group">
            <label>{{ $t('Neighborhood') }}</label>
            <input type="text" class="form-control" v-model="company.neighborhood">
            <ValidateMessage :error="validateErrors.neighborhood" />
          </div>
          <div class="form-group">
            <label>{{ $t('Address') }}</label>
            <input type="text" class="form-control" v-model="company.address">
            <ValidateMessage :error="validateErrors.address" />
          </div>
          <div class="form-group">
            <label>{{ $t('Zip code') }}</label>
            <input type="text" class="form-control" v-model="company.zipcode">
            <ValidateMessage :error="validateErrors.zipcode" />
          </div>
        </div>
      </div>
      <div class="form-group">
        <label>{{ $t('Description') }}</label>
        <textarea-autosize
          v-model="company.description"
          :min-height="30"
          class="form-control">
          </textarea-autosize>
        <ValidateMessage :error="validateErrors.description" />
      </div>
    </form>

    <template slot="footer">
      <div :class="{'box-loading': loading}">
        <button
          type="submit"
          form="company-form"
          class="btn btn-primary">{{ $t('Save') }}</button>
        <button
          type="button"
          class="btn btn-light"
          @click="hideModal()">{{ $t('Cancel') }}</button>
        <!--<button
            type="button"
            class="btn btn-danger"
            @click="deleteCompany(company._id)">{{ $t('Delete') }}</button>-->
      </div>
    </template>
      
  </modalo>

</template>

<script>
import SelectCountry from '@/components/Fields/SelectCountry'

export default {
  name: 'CompanyForm',
  components: {
    SelectCountry
  },
  props: [
    'initCompany'
  ],
  data () {
    return {
      loading: false,
      company: this.defaultValues(this.initCompany),
      validateErrors: {}
    }
  },
  created () {
  },
  methods: {
    /*
    defaultValues
    */
    defaultValues (values) {
      return values._id
      ? this.$clone(values)
      : Object.assign({
      }, values)
    },
    /*
    hideModal
    */
    hideModal () {
      this.$emit('hideModal')
    },
    /*
    saveCompany
    */
    saveCompany (data) {
      if (data._id) this.updateCompany(data)
      else this.createCompany(data)
    },
    /*
    createCompany
    */
    createCompany (data) {
      this.loading = true

      this.$store
      .dispatch('createCompany', data)
      .then((result) => {
        this.loading = false
        this.$emit('saved')
      })
      .catch((err) => {
        this.loading = false
        if (err.response.data.name === 'ValidationError') {
          this.validateErrors = err.response.data.errors
        }
      })
    },
    /*
    updateCompany
    */
    updateCompany (data) {
      this.loading = true

      this.$store
      .dispatch('updateCompany', data)
      .then((result) => {
        this.loading = false
        this.$emit('saved')
      })
      .catch((err) => {
        this.loading = false
        if (err.response.data.name === 'ValidationError') {
          this.validateErrors = err.response.data.errors
        }
      })
    },
    /*
    delete
    */
    deleteCompany (id) {
      const deleteAction = () => {
        this.loading = true

        this.$store
        .dispatch('deleteCompany', id)
        .then((result) => {
          this.loading = false
          this.$emit('saved')
        })
      }

      this.$store
      .dispatch('setAlertModal', {
        action: deleteAction
      })
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/Company/CompanyForm.vue